import React from "react";
import IconButton from "@material-ui/core/IconButton";
import MaterialModal from "components/modal/MaterialModal";
import CloseIcon from "@material-ui/icons/Close";

const DeleteModal = ({ modalVisible, closeModal, handleDeleteOkModal, target }) => {
  return (
    <MaterialModal open={modalVisible} closeModal={closeModal}>
      <div className="popup-content modal-width-130">
        <div className="popup-header">
          <div className="h-full">
            <IconButton aria-label="close" className="w-15 h-15" onClick={() => closeModal()}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <div className="popup-body flex flex-col justify-center items-center">
          <h3 className="text-xl font-bold text-danger mb-0 mt-2" id="modal-title">
            {`해당 ${target} 삭제 하시겠습니까?`}
          </h3>
          <p className="text-xs text-888 keep-words mt-2">삭제한 데이터는 복구가 불가능합니다.</p>
        </div>
        <div className="popup-footer center">
          <button type="button" className="btn btn-modal-x w-2/3 py-3 font-bold" onClick={() => handleDeleteOkModal()}>
            삭제
          </button>
        </div>
      </div>
    </MaterialModal>
  );
};

export default DeleteModal;
